import { render, staticRenderFns } from "./BrandPopup.vue?vue&type=template&id=330a9c15&scoped=true&"
import script from "./BrandPopup.vue?vue&type=script&lang=js&"
export * from "./BrandPopup.vue?vue&type=script&lang=js&"
import style0 from "./BrandPopup.vue?vue&type=style&index=0&id=330a9c15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a9c15",
  null
  
)

export default component.exports